module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "https://placehold.it/64x64",
      "alt": "social-ui"
    }
  }), _vm._v(" social-ui\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    class: _vm.navMenuClass,
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: _vm.navMenuClass
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-middle"
  }, [_c('span', {
    staticClass: "nav-item is-hidden-mobile"
  }, [_vm._v("\n            Profile style  \n            "), _c('profile-switcher')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'chatroomListing'
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })]), _vm._v("\n             \n            "), _c('span', [_vm._v("\n              Messages\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'profile',
        params: {
          profileId: 'me'
        }
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v("\n             \n            "), _c('span', [_vm._v("\n              Profile\n            ")])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-b438e73c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 293
// module chunks = 1